import MuiCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia, { CardMediaProps } from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface CardComponentProps {
    image?: CardMediaProps['image'];
    imageAlt?: string;
    kicker?: string;
    title: string;
    descr: string;
}

const CardComponent = (props: CardComponentProps) => (
    <MuiCard sx={cardSx}>
        {props.image && (
            <CardMedia
                component="img"
                height="170"
                image={props.image}
                alt={props.imageAlt || props.title}
                sx={cardImgSx}
            />
        )}
        <CardContent sx={contentSx}>
            <Box sx={topLineSx}>
                <Typography sx={kickerSx}>{props.kicker || 'GF'}</Typography>
                <Box sx={sparkSx} />
            </Box>
            <Typography gutterBottom variant="h5" component="div" sx={titleSx}>
                {props.title}
            </Typography>
            <Typography variant="body2" sx={descrSx}>
                {props.descr}
            </Typography>
        </CardContent>
    </MuiCard>
);

export default CardComponent;

const cardSx = {
    minHeight: '100%',
    color: '#fff',
    border: '1px solid rgba(255, 255, 255, .1)',
    borderRadius: '22px',
    background: 'linear-gradient(145deg, rgba(255,255,255,.09), rgba(255,255,255,.025))',
    boxShadow: '0 24px 70px rgba(0,0,0,.35)',
    overflow: 'hidden',
    transition: 'transform .2s ease, border-color .2s ease, box-shadow .2s ease',
    '&:hover': {
        transform: 'translateY(-6px)',
        borderColor: 'rgba(255, 127, 70, .55)',
        boxShadow: '0 32px 90px rgba(255, 84, 35, .16)'
    }
};

const cardImgSx = {
    p: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    boxSizing: 'border-box',
    filter: 'saturate(.85) contrast(1.05)'
};

const contentSx = {
    p: 3,
    background: 'linear-gradient(180deg, rgba(12,12,12,.72), rgba(5,5,5,.9))',
    minHeight: '220px'
};

const topLineSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 2
};

const kickerSx = {
    color: '#ff9b66',
    fontSize: '.78rem',
    fontWeight: 800,
    letterSpacing: '.16em',
    textTransform: 'uppercase'
};

const sparkSx = {
    width: '42px',
    height: '2px',
    borderRadius: '999px',
    background: 'linear-gradient(90deg, transparent, #ff6b2b, #ffd0ba)'
};

const titleSx = {
    color: '#fff',
    fontWeight: 800,
    letterSpacing: '-.02em'
};

const descrSx = {
    color: 'rgba(255,255,255,.72)',
    lineHeight: 1.7
};
